import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'
import _imports_1 from '@/app/ui/assets/svg/eye.svg'
import _imports_2 from '@/app/ui/assets/svg/invisible.svg'
import _imports_3 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'


const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "justify-end items-center flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none" }
const _hoisted_3 = { class: "relative w-screen md:w-8/12 lg:w-5/12 h-screen flex flex-col justify-between bg-white" }
const _hoisted_4 = { class: "border-b border-gray-lp-400 py-4" }
const _hoisted_5 = { class: "px-8 inline-flex justify-between w-full" }
const _hoisted_6 = { class: "font-semibold text-20px mr-4" }
const _hoisted_7 = {
  key: 0,
  class: "px-8 py-6 overflow-auto h-screen pb-32"
}
const _hoisted_8 = { class: "text-12px xxl:text-14px font-montserrat font-normal opacity-50" }
const _hoisted_9 = { class: "flex flex-row gap-x-3 items-center mt-2" }
const _hoisted_10 = { class: "text-20px font-semibold" }
const _hoisted_11 = { class: "mt-12" }
const _hoisted_12 = { class: "inline-flex flex-row w-full" }
const _hoisted_13 = { class: "list-disc px-6" }
const _hoisted_14 = { class: "text-12px xxl:text-14px opacity-50 mt-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-12px xxl:text-14px opacity-50"
}
const _hoisted_16 = {
  key: 1,
  class: "text-12px xxl:text-14px opacity-50"
}
const _hoisted_17 = {
  key: 2,
  class: "text-12px xxl:text-14px opacity-50"
}
const _hoisted_18 = {
  key: 3,
  class: "text-12px xxl:text-14px opacity-50"
}
const _hoisted_19 = { class: "inline-block relative w-full" }
const _hoisted_20 = {
  key: 0,
  src: _imports_1,
  alt: "",
  class: "h-6"
}
const _hoisted_21 = {
  key: 1,
  src: _imports_2,
  alt: "",
  class: "h-6"
}
const _hoisted_22 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 mr-10" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "text-sm text-red-lp-100 font-semibold bg-red-lp-1300 rounded-md px-5 py-2.5 text-center flex items-center gap-x-3 mt-4"
}
const _hoisted_25 = { class: "rounded-full bg-white p-2" }
const _hoisted_26 = { class: "rounded-full bg-red-lp-100 flex items-center justify-center p-1" }
const _hoisted_27 = {
  key: 1,
  class: "px-8 py-6 overflow-auto h-screen pb-32"
}
const _hoisted_28 = { class: "pb-8" }
const _hoisted_29 = { class: "pb-8" }
const _hoisted_30 = { class: "pb-8" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_OtpDisclaimer = _resolveComponent("OtpDisclaimer")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ModalOtp = _resolveComponent("ModalOtp")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("balance.withdraw.title")), 1),
                _createVNode("img", {
                  src: _imports_0,
                  class: "w-4 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                  alt: "x"
                })
              ])
            ]),
            (!_ctx.isLoadingData)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("p", _hoisted_8, _toDisplayString(_ctx.balanceTitle), 1),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("img", {
                      src: 
                  require(`@/app/ui/assets/svg/${
                    _ctx.balanceType === 'balance' ? 'coin' : 'cod'
                  }-red.svg`)
                ,
                      style: {"width":"22px","height":"auto"},
                      alt: "balance"
                    }, null, 8, ["src"]),
                    _createVNode("p", _hoisted_10, _toDisplayString(_ctx.formatPrice(_ctx.balance)), 1)
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('balance.withdraw.amountLabel'),
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("div", {
                            class: 
                      `bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 ${_ctx.errorAmountWithdrawal &&
                        'border-red-lp-100'} border outline-none focus:shadow items-center py-2 xxl:py-3 text-12px xxl:text-14px px-3`
                    
                          }, _toDisplayString(_ctx.withdrawCurrencyPrefix), 3),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                            onInput: _cache[3] || (_cache[3] = (e) => _ctx.formatted(e.target.value)),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.amountWithdrawal = $event)),
                            placeholder: _ctx.$t('balance.withdraw.amountPlaceholder'),
                            class: 
                      `py-1.5 xxl:py-3 px-3 mr-4 rounded-l-none rounded-r-md border ${
                        _ctx.errorAmountWithdrawal
                          ? 'border-red-lp-100'
                          : 'border-gray-lp-400'
                      } focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full`
                    
                          }, null, 42, ["placeholder"]), [
                            [_vModelText, _ctx.amountWithdrawal]
                          ])
                        ]),
                        _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.$t("balance.withdraw.minWithdrawMessage")) + " " + _toDisplayString(_ctx.formatPrice(_ctx.balanceRules[0]?.minWithdraw)), 513), [
                          [_vShow, _ctx.errorMinWithdraw]
                        ]),
                        _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.$t("balance.withdraw.balanceBelowMin")) + " " + _toDisplayString(_ctx.formatPrice(_ctx.balanceRules[0]?.minBalance)), 513), [
                          [_vShow, _ctx.errorMinBalance && _ctx.balanceType === 'balance']
                        ]),
                        _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.$t("balance.withdraw.balanceInsufficient")), 513), [
                          [_vShow, _ctx.errorMinBalance && _ctx.balanceType === 'cod']
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode("ul", _hoisted_13, [
                      _createVNode("li", _hoisted_14, _toDisplayString(_ctx.$t("balance.withdraw.minWithdraw")) + " " + _toDisplayString(_ctx.formatPrice(_ctx.balanceRules[0]?.minWithdraw)), 1),
                      (_ctx.balanceType === 'balance')
                        ? (_openBlock(), _createBlock("li", _hoisted_15, _toDisplayString(_ctx.$t("balance.withdraw.maxWithdrawOnceWeek")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.balanceType === 'balance')
                        ? (_openBlock(), _createBlock("li", _hoisted_16, _toDisplayString(_ctx.$t("balance.withdraw.maxWithdrawTotalMinBalance")) + " " + _toDisplayString(_ctx.formatPrice(_ctx.balanceRules[0]?.minBalance)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.balanceType === 'cod')
                        ? (_openBlock(), _createBlock("li", _hoisted_17, _toDisplayString(_ctx.$t("balance.withdraw.maxWithdrawTotal")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isAnyCashbackConfigActive)
                        ? (_openBlock(), _createBlock("li", _hoisted_18, _toDisplayString(_ctx.$t("balance.withdraw.cashbackDisclaimer")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('balance.withdraw.beneficiaryLabel'),
                      class: "mt-8 w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          "model-value": _ctx.beneficiaryModelValue,
                          disabled: true
                        }, null, 8, ["model-value"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('balance.withdraw.passwordLabel'),
                      class: "mt-6 w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode("div", _hoisted_19, [
                          _withDirectives(_createVNode("input", {
                            onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.validatePasswordAccount && _ctx.validatePasswordAccount(...args))),
                            type: _ctx.passwordType,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.password = $event)),
                            autocomplete: "current-password",
                            placeholder: _ctx.$t('balance.withdraw.passwordPlaceholder'),
                            class: ["block appearance-none w-full bg-white border px-4 py-3 pr-8 my-2 rounded shadow leading-tight focus:outline-none", {
                      'border-red-lp-700': _ctx.isWrongPassword,
                      'border-2': !_ctx.isWrongPassword
                    }]
                          }, null, 42, ["type", "placeholder"]), [
                            [_vModelDynamic, _ctx.password]
                          ]),
                          _createVNode("button", {
                            type: "button",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showPassword && _ctx.showPassword(...args))),
                            class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-6 text-gray-500 focus:outline-none"
                          }, [
                            (_ctx.iconType === 'eye')
                              ? (_openBlock(), _createBlock("img", _hoisted_20))
                              : (_openBlock(), _createBlock("img", _hoisted_21))
                          ]),
                          _withDirectives(_createVNode("div", _hoisted_22, [
                            _hoisted_23
                          ], 512), [
                            [_vShow, _ctx.isWrongPassword]
                          ])
                        ]),
                        _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.$t("balance.withdraw.passwordWrong")), 513), [
                          [_vShow, _ctx.isWrongPassword]
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_OtpDisclaimer, { show: _ctx.isRolloutOn }, null, 8, ["show"]),
                    (_ctx.errorMessageOtp)
                      ? (_openBlock(), _createBlock("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _createVNode("div", _hoisted_26, [
                              _createVNode(_component_Icons, {
                                name: "close",
                                class: "w-3 h-3 text-white"
                              })
                            ])
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.errorMessageOtp), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _createVNode(_component_skeleton, {
                      width: "8rem",
                      class: "my-2"
                    }),
                    _createVNode(_component_skeleton, { height: "2rem" })
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _createVNode(_component_skeleton, {
                      width: "8rem",
                      class: "my-2"
                    }),
                    _createVNode(_component_skeleton, { height: "2rem" })
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _createVNode(_component_skeleton, {
                      width: "8rem",
                      class: "my-2"
                    }),
                    _createVNode(_component_skeleton, { height: "2rem" })
                  ])
                ]))
          ])
        ]),
        _createVNode("div", {
          class: "w-full md:w-5/12 z-20 absolute bottom-0 items-center flex flex-row rounded-b-md text-xs bg-gray-lp-700 justify-center md:justify-end px-8 py-4",
          style: `${_ctx.isShowRunningText ? 'bottom: 16px;' : ''}`
        }, [
          _createVNode(_component_button_outline, {
            custom: "bg-white px-12 border border-gray-lp-500 text-gray-lp-500 mr-4",
            title: _ctx.$t('balance.withdraw.cancel'),
            onClick: _ctx.onClose
          }, null, 8, ["title", "onClick"]),
          (_ctx.isVisibleRequest)
            ? (_openBlock(), _createBlock(_component_button_fill, {
                key: 0,
                custom: "px-12 bg-red-lp-200",
                title: _ctx.$t('balance.withdraw.withdraw'),
                onClick: _ctx.onSubmitWithdraw,
                isDisabled: _ctx.isDisabled
              }, null, 8, ["title", "onClick", "isDisabled"]))
            : _createCommentVNode("", true)
        ], 4)
      ]),
      _hoisted_31
    ]),
    _createVNode(_component_ModalOtp, {
      modelValue: _ctx.isModalOtp,
      "onUpdate:modelValue": [
        _cache[8] || (_cache[8] = ($event: any) => (_ctx.isModalOtp = $event)),
        _ctx.onUpdateOpenOtp
      ],
      email: _ctx.emailUser,
      phone: _ctx.phoneUser,
      password: _ctx.password,
      action: _ctx.actionRequestOtp,
      onVerify: _ctx.onVerify,
      isWithdraw: ""
    }, null, 8, ["modelValue", "onUpdate:modelValue", "email", "phone", "password", "action", "onVerify"])
  ], 64))
}